import "./Loading.scss"
import defaultLoadingLogo from "../../assets/images/loading/Loading-Dual-Ball.svg"
const Loading = () => {
    return (
        <div className="LoadingBeforeFetchInfo">
            <img className="logo" src={defaultLoadingLogo} alt="logo" />
            <div className="loadingProgressBarContainer mt-4">
                <div className="loadingProgressBar"></div>
            </div>
            <span className="font-16 mt-3 iranyekan-bold">
                در حال دریافت اطلاعات...
            </span>
        </div>
    )
}

export default Loading